// Copyright (c) 2017 Deere & Company

import SearchFilters from '../state/search-filters';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const resetSearchFilters = state =>
    SearchFilters.update(state, {
        $set: getDefaultState().searchFilters
    });

const updateSearchFilters = (state, action) =>
    SearchFilters.update(state, {
        [action.property]: {
            $set: action.payload
        }
    });

const actionTypes = {
    [actions.RESET_CLAIMS_IN_PROGRESS]: resetSearchFilters,
    [actions.UPDATE_CLAIMS_IN_PROGRESS_FILTER_BY]: updateSearchFilters,
    [actions.UPDATE_CLAIMS_IN_PROGRESS_SORT_BY]: updateSearchFilters,
    [actions.UPDATE_CLAIMS_IN_PROGRESS_SORT_DIRECTION]: updateSearchFilters
};

export default (state = getDefaultState().searchFilters, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/reducers/search-filters.js